function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M30.4811 0.64153L26.8401 1.91933L28.1497 6.0519L17.3023 0.428558L2.60681 8.52639V19.4486L8.50321 17.3544L8.46275 11.9136L17.3023 7.20801L25.7476 11.3406L21.5301 12.8973L22.8651 16.7104L34.5114 12.5373L30.4811 0.64153Z",
  fill: "currentColor"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M4.10266 37.3635L7.7437 36.0807L6.43408 31.9481L17.2763 37.5715L31.9721 29.4787V18.5564L26.0805 20.6455L26.121 26.0864L17.2763 30.797L8.83105 26.6644L13.0485 25.1027L11.7136 21.2947L0.0723877 25.4627L4.10266 37.3635Z",
  fill: "currentColor"
});

function SvgYflink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 38,
    viewBox: "0 0 35 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYflink);
export default __webpack_public_path__ + "static/media/yflink.c4b69a19.svg";
export { ForwardRef as ReactComponent };